module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elRulesCopy_443106.78b2ec93.jpg";